import { h } from "preact";

import AvatarPreviewPopover, { AvatarPreviewPopoverProps } from "../../../apps/containers/AvatarPreviewPopover";
import classname from "../../../foundation/utils/classname";
import { exists } from "../../../foundation/utils/object";
import Avatar, { AvatarProps } from "../Avatar";

import styles from "./MemberCell.module.css";

interface Props {
    class?: string;
    selected?: boolean;
    avatarProps: Pick<AvatarProps, "src" | "srcset" | "type">;
    displayName?: string;
    email?: string;
    pendingInvitation?: boolean;
    avatarPreviewPopoverProps?: Pick<AvatarPreviewPopoverProps, "userId">;
    indicatorIcon?: JSX.Element;
}

function MemberCell({
    class: cssClass,
    selected,
    displayName,
    email,
    avatarProps,
    pendingInvitation,
    avatarPreviewPopoverProps,
    indicatorIcon
}: Props) {
    function renderDisplayName() {
        return (
            <span class={classname(styles.memberLabel, "ellipsis")} title={displayName}>{displayName}</span>
        );
    }

    return (
        <div class={classname(styles.memberCell, cssClass, "body-1", {
            [styles.selectable]: exists(selected),
            [styles.selected]: selected
        })}>
            <Avatar
                class={styles.avatar}
                {...avatarProps}/>
            <div class={classname(styles.memberInfoWrapper, "ellipsis")}>
                {
                    avatarPreviewPopoverProps ? (
                        <AvatarPreviewPopover userId={avatarPreviewPopoverProps.userId}>
                            {renderDisplayName()}
                        </AvatarPreviewPopover>
                    ) : (
                        renderDisplayName()
                    )
                }
                {
                    pendingInvitation ? (
                        <span class={classname(styles.memberEmail, "ellipsis")}>Pending Invitation</span>
                    ) : (
                        <span class={classname(styles.memberEmail, "ellipsis")} title={email}>{email}</span>
                    )
                }
            </div>
            {
                indicatorIcon && (
                    <div class={styles.inviteMember}>
                        {indicatorIcon}
                    </div>
                )
            }
        </div>
    );
}

export default MemberCell;
